<template>
  <el-form ref="form" label-width="160px" size="medium">
    <el-table size="medium" :data="list" :show-header="false" class="form-table">
      <el-table-column>
        <template slot-scope="{row}">
          <el-form-item :label="row.title">
            <el-input v-model="row.value" type="number" :placeholder="`请输入${row.title}`">
              <span v-if="row.name == 'blindNumber'" slot="append">单</span>
              <span v-else-if="row.name == 'blindOrder'" slot="append">单</span>
              <span v-else-if="row.name == 'blindAmount'" slot="append">元</span>
              <span v-else slot="append">%</span>
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <el-form-item v-if="list && list.length" label-width="170px" style="margin-top: 22px">
      <el-button type="primary" @click="onSubmit">提交保存</el-button>
      <el-button>取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    onSubmit() {}
  }
}
</script>

<style lang="scss" scoped>
@import url('./config.scss');
</style>
